import { useFormContext } from 'react-hook-form';

import { ToggleSwitch } from '../../../../../../components/toggle-switch';
import { StrategyFormData } from '../../../../../../providers/backtesting/types';
import { CollapsibleSection } from '../../components/collapsible-section';
import { BacktestingInput } from '../../components/backtesting-input';
import { BacktestingSelect } from '../../components/backtesting-select';
import { FormRow } from '../../components/form-row';

import './styles.scss';

const TOKEN_OPTIONS = [
  { name: 'BTC', value: 'BTC' },
  { name: 'ETH', value: 'ETH' },
  { name: 'SOL', value: 'SOL' },
];

export const AccountInformationSection = () => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<StrategyFormData>();

  const includeInitialPerpetual = watch('accountInformation.includeInitialPerpetual');
  const selectedToken =
    TOKEN_OPTIONS.find((option) => option.value === watch('accountInformation.token')) ??
    TOKEN_OPTIONS[0];

  const hasErrors = !!(
    errors.accountInformation?.token ||
    errors.accountInformation?.tokenBalance ||
    errors.accountInformation?.usdBalance ||
    errors.accountInformation?.initialPerpetualBalance
  );

  return (
    <CollapsibleSection title="Account Information*">
      <FormRow
        className={`account-information-grid${hasErrors ? ' account-information-grid--has-errors' : ''}`}
      >
        <div className="field-group">
          <label className="field-label">Token*</label>
          <BacktestingSelect
            values={TOKEN_OPTIONS}
            defaultValue={selectedToken}
            onChange={(value) =>
              setValue('accountInformation.token', value, {
                shouldDirty: true,
                shouldValidate: true,
              })
            }
          />
          {errors.accountInformation?.token && (
            <span className="field-error">{errors.accountInformation.token.message}</span>
          )}
        </div>
        <div className="field-group">
          <BacktestingInput
            label="Token Balance*"
            placeholder="Initial token holding"
            {...register('accountInformation.tokenBalance')}
            errors={errors.accountInformation?.tokenBalance?.message}
          />
        </div>
        <div className="field-group">
          <BacktestingInput
            label="USD Balance*"
            placeholder="Initial USD balance"
            {...register('accountInformation.usdBalance')}
            errors={errors.accountInformation?.usdBalance?.message}
          />
        </div>
        <div className="toggle-inline account-information-toggle">
          <ToggleSwitch
            isOn={includeInitialPerpetual}
            setIsOn={(val) =>
              setValue('accountInformation.includeInitialPerpetual', val, {
                shouldDirty: true,
                shouldValidate: true,
              })
            }
          />
          <span className="toggle-inline-label">Include Initial Perpetual to trade (in token)</span>
        </div>
        {includeInitialPerpetual && (
          <div className="field-group">
            <BacktestingInput
              placeholder="Initial Perpetual balance"
              {...register('accountInformation.initialPerpetualBalance')}
              errors={errors.accountInformation?.initialPerpetualBalance?.message}
            />
          </div>
        )}
      </FormRow>
    </CollapsibleSection>
  );
};
